import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Pipe({
  name: 'getUserById',
})
export class GetUserByIdPipe implements PipeTransform {
  constructor(private store: AngularFirestore) {}

  transform(id: string, ...args: unknown[]): Observable<any> {
    return this.store.collection('user').doc(id).valueChanges();
  }
}
